module.exports = require('./helpers/bundle-url').getBundleURL('lldAp') + "logo-dark.eefe0b7f.svg";